export const directfulServiceTypes = {
  PlatformAccessFee: 'PlatformAccessFee',
  Marketing: 'Marketing',
  MarketingWithCommission: 'MarketingWithCommission',
  Messaging: 'Messaging',
  Unlimited: 'Unlimited',
  DirectfulCore: 'Directful Core',
  Basic: 'Basic',
  Email: 'Email'
}

export const directfulServiceNames = {
  CoreServices: 'Directful Core Services',
  PlatformAccessFee: 'Platform access fee',
  Marketing: 'Marketing',
  MarketingWithCommission: 'Marketing with commission',
  Messaging: 'In-property messaging',
  Unlimited: 'In-property unlimited',
  Basic: 'In-property basic',
  DirectfulCore: 'Directful Core'
}
